import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

// GDPR cookie consent bar (bottom). Choice persisted in localStorage.
export const CookieConsent = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const choice = localStorage.getItem("ed_cookie_consent");
    const onSignPage = ["/podpis-spoluprace", "/flotila", "/admin", "/klient", "/prace"].some((p) => pathname.startsWith(p));
    setVisible(!choice && !onSignPage);
  }, [pathname]);

  const decide = (value) => {
    localStorage.setItem("ed_cookie_consent", value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-30 px-3 sm:px-5 py-2.5 bg-[#0d0d0d]/95 backdrop-blur-md border-t border-white/10 flex flex-wrap sm:flex-nowrap items-center justify-center gap-x-4 gap-y-2 animate-fade-in-up"
      data-testid="cookie-consent"
    >
      <p className="text-zinc-400 text-[11px] sm:text-xs leading-snug inline-flex items-center gap-2 min-w-0">
        <Cookie className="w-3.5 h-3.5 text-indigo-400 flex-shrink-0" />
        <span>
          {t("cookie.text")}{" "}
          <a href="/gdpr" className="text-indigo-400 hover:underline whitespace-nowrap">{t("cookie.more")}</a>
        </span>
      </p>
      <div className="flex items-center gap-2 shrink-0">
        <button onClick={() => decide("declined")} className="px-3 py-1.5 text-xs rounded-full border border-white/15 text-zinc-300 hover:text-white hover:border-white/30 transition-colors" data-testid="cookie-decline">
          {t("cookie.decline")}
        </button>
        <button onClick={() => decide("accepted")} className="btn-accent text-xs px-4 py-1.5" data-testid="cookie-accept">
          {t("cookie.accept")}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
